import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import { pushLoader } from "../../actions/main";

import {
  pushNotif,
  fetchNotifAll,
  deleteNotif,
  updateNotif
} from "../../api/notification";

import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerText: "",
      bodyText: "",
      footerText: "",
      dateNotif: "",
      datatable: [],
      openAdd: false,
      openEdit: false,
      uid: 0,
      loader: null
    };
  }

  componentDidMount() {
    this.getDatatable();
  }

  restate = args => {
    this.setState({
      uid: args[0],
      dateNotif: args[1],
      headerText: args[2],
      footerText: args[3],
      bodyText: args[4],
      openEdit: true
    });
    // this.updating()
  };

  updating = () => {
    updateNotif(
      this.state.headerText,
      this.state.bodyText,
      this.state.footerText,
      this.state.dateNotif,
      this.state.uid
    )
      .then(response => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            headerText: "",
            bodyText: "",
            footerText: "",
            dateNotif: "",
            openEdit: false
          });
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({loader: true})
    fetchNotifAll()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.setState({loader: false})
        this.props.pushLoader(false)
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeheaderText = e => {
    this.setState({ headerText: e.target.value });
  };

  handleDelete = id => {
    deleteNotif(id)
      .then(response => {
        if (response != null) {
          this.getDatatable();
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangebodyText = e => {
    this.setState({ bodyText: e.target.value });
  };

  handleChangefooterText = e => {
    this.setState({ footerText: e.target.value });
  };

  handleChangedateNotif = event => {
    //console.log(moment(event._d).format("YYYY-MM-DD kk:mm:ss"));
    this.setState({ dateNotif: moment(event._d).format("YYYY-MM-DD") });
  };

  handleSubmit = () => {
    pushNotif(
      this.state.headerText,
      this.state.bodyText,
      this.state.footerText,
      this.state.dateNotif
    )
      .then(response => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            headerText: "",
            bodyText: "",
            footerText: "",
            dateNotif: "",
            openAdd: false
          });
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Notification</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <GridItem xs={10} sm={10} md={10}>
              <Card>
                <CardHeader color="rose" icon>
                  <Button
                    color="success"
                    round
                    onClick={() => this.handleClose("openAdd", true)}
                  >
                    Add Notification
                  </Button>
                </CardHeader>
                <NotifList
                  datatable={this.state.datatable}
                  handleDelete={this.handleDelete}
                  restate={this.restate}
                  loader={this.state.loader}
                />
              </Card>
              <Dialog
                fullScreen
                open={this.state.openAdd}
                onClose={() => this.handleClose("openAdd", false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">
                  Add Notification
                </DialogTitle>
                <DialogContent>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Header Texts"
                        id="headerText"
                        inputProps={{
                          value: this.state.headerText,
                          onChange: this.handleChangeheaderText
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Body Text"
                        id="bodyText"
                        inputProps={{
                          value: this.state.bodyText,
                          onChange: this.handleChangebodyText
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Footer Text"
                        id="footerText"
                        inputProps={{
                          value: this.state.footerText,
                          onChange: this.handleChangefooterText
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel>Date Announcement</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          timeFormat={false}
                          dateFormat="LL"
                          onChange={this.handleChangedateNotif}
                          inputProps={{
                            placeholder: "Date Picker Here"
                          }}
                          value={this.state.dateNotif}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openAdd", false)}
                    color="default"
                    round
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this.handleSubmit()}
                    color="success"
                    round
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                fullScreen
                open={this.state.openEdit}
                onClose={() => this.handleClose("openEdit", false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">
                  Update Notification
                </DialogTitle>
                <DialogContent>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Header Texts"
                        id="headerText"
                        inputProps={{
                          value: this.state.headerText,
                          onChange: this.handleChangeheaderText
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Body Text"
                        id="bodyText"
                        inputProps={{
                          value: this.state.bodyText,
                          onChange: this.handleChangebodyText
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Footer Text"
                        id="footerText"
                        inputProps={{
                          value: this.state.footerText,
                          onChange: this.handleChangefooterText
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel>Date Announcement</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          timeFormat={false}
                          dateFormat="LL"
                          onChange={this.handleChangedateNotif}
                          inputProps={{
                            placeholder: "Date Picker Here"
                          }}
                          value={this.state.dateNotif}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openEdit", false)}
                    color="default"
                    round
                  >
                    Cancel
                  </Button>
                  <Button onClick={() => this.updating()} color="success" round>
                    Update
                  </Button>
                </DialogActions>
              </Dialog>
            </GridItem>
          </Grid>
        </Grid>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(mapStateToProps, {pushLoader})(withStyles(styles)(Notification)));
